import { InquiryPayload } from "./InquiryPayload";

const MAIL_API_URL = process.env.REACT_APP_MAIL_API_URL?.trim();
// Lambda Function URLs akzeptieren maximal 6 MB Base64-kodiert (~4,5 MB roh);
// etwas Reserve für Formularfelder und Multipart-Overhead.
export const MAX_ATTACHMENT_BYTES = Math.floor(4.3 * 1024 * 1024);

export async function sendMail(
  text: string,
  html?: string,
  attachments: File[] = [],
  subject = "Anfrage via AutoGutVerkaufen.de",
  payload?: InquiryPayload,
) {
  if (!MAIL_API_URL) {
    throw new Error("REACT_APP_MAIL_API_URL ist nicht konfiguriert");
  }

  const attachmentBytes = attachments.reduce(
    (total, file) => total + file.size,
    0,
  );
  if (attachmentBytes > MAX_ATTACHMENT_BYTES) {
    throw new Error(
      "Die Anhänge sind zusammen zu groß (max. ca. 4 MB). Bitte entfernen Sie einzelne Bilder und senden Sie erneut.",
    );
  }

  let formdata = new FormData();

  formdata.append("subject", subject);

  formdata.append("text", text);
  if (html) formdata.append("html", html);
  if (payload) formdata.append("payload", JSON.stringify(payload));
  attachments.forEach((file) => {
    formdata.append("attachment", file, file.name);
  });

  const requestOptions = {
    method: "POST",
    body: formdata,
  };

  return await fetch(MAIL_API_URL, requestOptions);
}
